import React, { useState } from 'react'
import { TradingEntityAssignmentDetail, FundTradingEntityAssignment } from 'api'
import { Heading, SearchBar, ScrollContainer, NoEntities, AvailableTable } from '../allocationDialogStyles'
import { SelectButton } from 'view/components/options/optionsStyles'
import { TextButtonType } from 'view/components/buttons'
import { Locale, Translation } from 'locale'
import { uniqBy } from 'lodash'

interface AvailableTradingEntitiesPanelProps {
  assignmentDetails: TradingEntityAssignmentDetail[]
  onAddNewAssignment: (assignment: FundTradingEntityAssignment) => void
}

export const AvailableTradingEntitiesPanel: React.FC<AvailableTradingEntitiesPanelProps> = props => {
  const { assignmentDetails } = props
  const [search, setSearch] = useState('')

  const filteredAssignmentDetails = uniqBy(assignmentDetails, d => d.tradingEntityAssignment.tradingEntityId).filter(
    assignmentDetail =>
      assignmentDetail.tradingEntity.id.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
      assignmentDetail.tradingEntity.shortName.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
      assignmentDetail.tradingEntity.publishedName.toLocaleLowerCase().includes(search.toLocaleLowerCase())
  )

  return (
    <>
      <Heading>
        {Locale.translate(Translation.SC_AVAILABLE_TRADING_ENTITIES_TO_ALLOCATE)} ({assignmentDetails.length}):
      </Heading>
      <SearchBar
        dataTestId={'AvailableTradingEntitiesPanel-TradingEntitiesSearchBar'}
        value={search}
        onUpdate={value => setSearch(value)}
        placeholder={Locale.translate(Translation.SC_SEARCH_TRADING_ENTITIES)}
      />
      <ScrollContainer maxHeight={410}>
        <AvailableTable data-test-id="AvailableTradingEntitiesPanel-Table">
          <thead>
            <tr>
              <th colSpan={2}>{Locale.translate(Translation.TC_PUBLISHED_NAME)}</th>
            </tr>
          </thead>
          {filteredAssignmentDetails.length > 0 && (
            <tbody>
              {filteredAssignmentDetails.map((assignmentDetail, idx) => {
                const {
                  tradingEntity: { publishedName, id }
                } = assignmentDetail

                return (
                  <tr key={`${id}-${idx}`} data-test-id={`AvailableTradingEntitiesPanel-Row-${publishedName}`}>
                    <td style={{ width: 340 }}>{publishedName}</td>
                    <td style={{ width: 65 }}>
                      <SelectButton
                        dataTestId={'AvailableTradingEntitiesPanel-SelectButton-AddButton'}
                        selected={true}
                        disabled={false} // !canTrade
                        type={TextButtonType.Primary}
                        onClick={() => props.onAddNewAssignment(assignmentDetail.tradingEntityAssignment)}>
                        {Locale.translate(Translation.TC_BUTTON_ADD)}
                      </SelectButton>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          )}
        </AvailableTable>
        {filteredAssignmentDetails.length === 0 && <NoEntities>{Locale.translate(Translation.SC_NO_TRADING_ENTITIES_FOUND)}</NoEntities>}
      </ScrollContainer>
    </>
  )
}
